const FLOW = [
  {
    step: "01",
    title: "ご相談",
    desc: "お問い合わせフォームから、現在発生している現象や課題をお知らせください。まずは案件として対応可能かを確認します。",
    icon: "ri-chat-3-line",
  },
  {
    step: "02",
    title: "必要に応じてNDA",
    desc: "技術情報や工程情報を扱う場合、必要に応じて秘密保持契約を締結します。",
    icon: "ri-file-shield-2-line",
  },
  {
    step: "03",
    title: "現場確認",
    desc: "工程、現物、データを現場で確認します。初期段階では、できる限り一次情報に触れることを重視します。",
    icon: "ri-building-4-line",
  },
  {
    step: "04",
    title: "評価方法・改善効果の定義を合意",
    desc: "投入数・完成数、不良率、対象項目、評価期間などを整理し、何をもって改善と判断するかを事前に合意します。",
    icon: "ri-file-list-3-line",
  },
  {
    step: "05",
    title: "原因究明",
    desc: "仮説設定、切り分け、必要な検証、データ分析を通じて原因を絞り込みます。",
    icon: "ri-search-eye-line",
  },
  {
    step: "06",
    title: "改善案の設計",
    desc: "原因に対して、材料・工程・条件・治工具・作業方法などの改善案を設計します。",
    icon: "ri-draft-line",
  },
  {
    step: "07",
    title: "お客様側で検証",
    desc: "改善案は原則としてお客様の現場で検証いただきます。必要に応じて評価方法や検証条件の整理を支援します。",
    icon: "ri-flask-line",
  },
  {
    step: "08",
    title: "効果確認",
    desc: "事前に合意した評価方法で改善効果を確認し、成果報酬が発生する場合は、その結果に基づいて算定します。",
    icon: "ri-shield-check-line",
  },
];

export default function Flow() {
  return (
    <section id="flow" className="w-full py-24 md:py-32 bg-background-200/60">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Flow</span>
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug mb-6">
            <a href="#flow" className="cursor-pointer">ご相談から改善までの流れ</a>
          </h4>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            初回のご相談から効果確認まで、以下の8ステップで進めます。
            各ステップで合意を取りながら丁寧に進めますので、ご安心ください。
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-6 top-0 bottom-0 w-[1px] bg-background-300" />

          <div className="space-y-4 md:space-y-6">
            {FLOW.map((s, i) => (
              <div
                key={s.step}
                className="relative md:pl-20 bg-background-50 border border-background-200 rounded-lg p-6 md:p-7 hover:border-primary-300 transition-colors"
              >
                <div className="hidden md:flex absolute -left-0 top-6 w-12 h-12 items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-sm z-10 border-4 border-background-200">
                  {s.step}
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:hidden shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-heading">
                    {s.step}
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-8 h-8 hidden md:flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                        <i className={`${s.icon} text-sm`}></i>
                      </div>
                      <h5 className="font-heading text-lg md:text-xl text-foreground-900">
                        {s.title}
                      </h5>
                    </div>
                    <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed md:ml-11">
                      {s.desc}
                    </p>
                  </div>
                </div>
                {i < FLOW.length - 1 && (
                  <div className="hidden md:block absolute left-6 -bottom-3 w-3 h-3 -translate-x-1/2 rotate-45 border-r border-b border-background-300 bg-background-200/60" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}